import { Container, Typography, Grid, Card, CardMedia, CardContent, Box } from "@mui/material";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SchoolIcon from '@mui/icons-material/School';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const AboutUs = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            {/* Heading Section */}
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 }}>
                Hi there, <span style={{ color: "#3f51b5" }}>I'm Abhiram</span>
            </Typography>

            {/* Description Section */}
            <Grid container spacing={4}>
                {/* Text Section */}
                <Grid item xs={12} md={8}>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        <strong>
                            I have 10+ Years of experience On Cloud Architecture (Azure Data Factory, Databricks, pyspark) with Real time scenarios and Real time projects.
                        </strong>
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Extensively worked on all facets of data warehousing including requirement gathering, gap
                        analysis, database design, data integration, data modeling, enterprise reporting, data
                        analytics, data quality, data visualization, OLAP. Has worked on a broad range of business
                        verticals and holds exceptional expertise on various ETL tools.
                    </Typography>
                    <Typography variant="body1">
                        Having experienced initial troubles faced by newcomers to the field, I thought that I should
                        share my experience—not just technical details but fine details—so that one can become
                        confident about Informatica. With that as motivation, I started this journey of training and
                        making people job-ready through proper guidance and help. With completing 15+ batches and seeing
                        the success stories, it gives me great joy and satisfaction much more than my regular job!
                    </Typography>
                </Grid>

                {/* Profile Image Section */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ maxWidth: 345, boxShadow: 3 }}>
                        <CardMedia
                            component="img"
                            height="250"
                            image="/images/nataraj.jpg" // Replace with actual image URL
                            alt="Abhiram Naidu"
                        />
                        <CardContent>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                G.Abhiram Naidu
                            </Typography>
                            <Typography variant="subtitle1" color="textSecondary">
                                Founder & Instructor
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Box
                sx={{
                    backgroundColor: "#f3f2fc",
                    py: 6,
                    textAlign: "center",
                    borderRadius: "12px", // Rounded corners
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Soft shadow
                    mt: 6, // Increased margin-top for better spacing
                }}
            >
                <Container>
                    <Typography
                        variant="h4"
                        sx={{ fontWeight: "bold", mb: 4 }}
                    >
                        Let the numbers <span style={{ color: "#3F51B5" }}>Speak</span>
                    </Typography>
                    <Grid container spacing={4} justifyContent="center">
                        {[
                            { number: "10,000+", label: "LEARNERS" },
                            { number: "7,000+", label: "STUDENTS PLACED" },
                            { number: "400+", label: "COURSE HOURS" },
                            { number: "3,000+", label: "REVIEWS" },
                        ].map((item, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <Typography
                                    variant="h3"
                                    sx={{ color: "#3F51B5", fontWeight: "bold", mb: 1 }}
                                >
                                    {item.number}
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: "bold", color: "#333" }}
                                >
                                    {item.label}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Our Core Values Section */}
            <Box sx={{ py: 6, textAlign: "center", mt: 6 }}>
                <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 }}>
                    Our <span style={{ color: "#3F51B5" }}>Core Values</span>
                </Typography>
                <Typography variant="body1" sx={{ maxWidth: 800, mx: "auto", mb: 4 }}>
                    Cloud UpSkill is designed to meet industry benchmarks. Our Cloud UpSkill
                    certification courses are designed by Mr. Abhiram with 10+ years of industry experience.
                </Typography>

                <Grid container spacing={4} justifyContent="center">
                    {[
                        {
                            icon: <SchoolIcon sx={{ fontSize: 40, color: "#3F51B5" }} />,
                            title: "Realtime Based Projects",
                            description: "Learn with real-time based projects and interview preparation."
                        },
                        {
                            icon: <BusinessCenterIcon sx={{ fontSize: 40, color: "#3F51B5" }} />,
                            title: "Get Job Ready Course",
                            description: "Learn from basics to advanced Informatica, Oracle, SQL, UNIX, and more to get job-ready."
                        },
                        {
                            icon: <TrendingUpIcon sx={{ fontSize: 40, color: "#3F51B5" }} />,
                            title: "Build Better Career",
                            description: "Learn new skills with hands-on experience in real-life Informatica projects."
                        },
                    ].map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card sx={{ p: 3, textAlign: "center", boxShadow: 3, borderRadius: 3 }}>
                                <Box sx={{ mb: 2 }}>{item.icon}</Box>
                                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                                    {item.title}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {item.description}
                                </Typography>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
};

export default AboutUs;
